import { useUser } from "@auth";
import { AirdropPageTemplateProps } from "./template";
import { useGetAllGiftCardOffers, useGetPartnerAirdropTransactions } from "@queries";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../auth/auth-context";


export const useAirdropPage = (): AirdropPageTemplateProps => {
    const navigate = useNavigate();
    const partner = useUser();
    const { getAllGiftCardOffers } = useGetAllGiftCardOffers();
    const { getPartnerAirdropTransactions, airdropTransactions, loading, error } = useGetPartnerAirdropTransactions();
    const { giftCardOffers, partnerAirdropTransactions: cachedAirdropTransactions, creditCardStatus } = useContext(AuthContext);

    useEffect(() => {
        if (giftCardOffers == null) {
            getAllGiftCardOffers();
        }
    }, [giftCardOffers, getAllGiftCardOffers]);

    useEffect(() => {
         // if (!cachedAirdropTransactions || cachedAirdropTransactions.length === 0) { // note: old logic, just in case
        if (cachedAirdropTransactions == null) {
            getPartnerAirdropTransactions();
        }
    }, [cachedAirdropTransactions, getPartnerAirdropTransactions]);

    const navigateToPage = (index: number, to: string) => {
        navigate(to);
      }

    const onReturnPressed = () => {
        navigate(-1);
    }

    return {
        premiumUsers: partner?.premiumSettings?.[0]?.users.filter(item => !!item.userId) || [],
        giftCardOffers,
        navigateToPage,
        onReturnPressed,
        partnerAirdropTransactions: airdropTransactions ?? cachedAirdropTransactions ?? [],
        isHistoryLoading: loading,
        historyError: error ?? null,
        creditCardStatus,
    }
}
